import { activateModal } from "./utils/modal";

class UiHeader extends HTMLElement {
  header?: HTMLElement | null;
  searchModal?: Element | null;

  constructor() {
    super();
  }

  connectedCallback() {
    this.header = document.getElementById("shopify-section-header");

    this.handleSubmenuHovers();
    this.handleSearch();
  }

  handleSearch() {
    this.querySelectorAll<HTMLElement>("[data-header-search]").forEach((container) => {
      const input = container.querySelector<HTMLInputElement>("input")!;
      const trigger = container.querySelector<HTMLButtonElement>("[data-open-search]")!;
      const closeButton = container.querySelector<HTMLButtonElement>("[data-close-search]")!;
      let release: (() => void) | undefined;
      input.tabIndex = -1;

      const close = () => {
        container.dataset.searchOpen = "false";
        container.removeAttribute("role");
        container.removeAttribute("aria-modal");
        container.removeAttribute("aria-labelledby");
        trigger.setAttribute("aria-expanded", "false");
        closeButton.hidden = true;
        input.tabIndex = -1;
        input.blur();
        release?.();
        release = undefined;
      };

      const open = () => {
        if (container.dataset.searchOpen === "true") return;
        container.dataset.searchOpen = "true";
        container.setAttribute("role", "dialog");
        container.setAttribute("aria-modal", "true");
        container.setAttribute("aria-labelledby", `${input.id}-label`);
        trigger.setAttribute("aria-expanded", "true");
        closeButton.hidden = false;
        input.tabIndex = 0;
        release = activateModal(container, input, close, trigger);
      };

      trigger.addEventListener("click", open);
      input.addEventListener("focus", open);
      closeButton.addEventListener("click", close);
    });
  }

  handleSubmenuHovers() {
    const header = document.querySelector(".header-wrapper");
    const triggers = Array.from(this.querySelectorAll<HTMLAnchorElement>(".with-submenu"));

    const setExpanded = (trigger: HTMLAnchorElement, expanded: boolean) => {
      trigger.setAttribute("aria-expanded", String(expanded));
      trigger.parentElement?.toggleAttribute("open", expanded);
      header?.toggleAttribute("open", triggers.some((item) => item.getAttribute("aria-expanded") === "true"));
    };

    triggers.forEach((element) => {
      const menu = element.parentElement!;
      let hoverTimer: ReturnType<typeof setTimeout>;
      setExpanded(element, false);

      const open = () => {
        triggers.forEach((trigger) => setExpanded(trigger, trigger === element));
      };

      element.addEventListener("keydown", (event) => {
        if (event.key !== " ") return;
        event.preventDefault();
        clearTimeout(hoverTimer);
        if (menu.hasAttribute("open")) setExpanded(element, false);
        else open();
      });

      menu.addEventListener("focusin", () => {
        clearTimeout(hoverTimer);
        open();
      });

      menu.addEventListener("mouseenter", () => {
        const timeout = header?.hasAttribute("open") ? 0 : 150;
        clearTimeout(hoverTimer);
        hoverTimer = setTimeout(() => {
          if (menu.matches(":hover")) open();
        }, timeout);
      });

      menu.addEventListener("mouseleave", () => {
        clearTimeout(hoverTimer);
        hoverTimer = setTimeout(() => {
          if (!menu.matches(":hover") && !menu.contains(document.activeElement)) {
            setExpanded(element, false);
          }
        }, 100);
      });

      menu.addEventListener("focusout", (event) => {
        if (!menu.contains(event.relatedTarget as Node | null)) {
          clearTimeout(hoverTimer);
          setExpanded(element, false);
        }
      });

      menu.addEventListener("keydown", (event) => {
        if (event.key === "Escape" && menu.hasAttribute("open")) {
          event.preventDefault();
          clearTimeout(hoverTimer);
          element.focus();
          setExpanded(element, false);
        }
      });
    });
  }

  closeSearchModal() {
    this.searchModal = this.searchModal || this.header?.querySelector("details-modal");
    this.searchModal?.close(false);
  }
}

customElements.define("ui-header", UiHeader);
